module.exports = __webpack_public_path__ + "images/fsoel_schnellrechner_scenario_2_web.svg?777d957d10c2a1f59b3597dd23f96a0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fsoel_schnellrechner_scenario_2_web.svg
// module id = kICM
// module chunks = 0